import styled from "styled-components";
 
export const GeneralContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
`;

export const GeneralFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 24px;
`;

export const GeneralFormColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 500px;
  gap: 16px;

  input {
    border-radius: 8px;
    border: 1px solid ${props => props.theme.colors.clearGray};
    background: ${props => props.theme.colors.primaryWhite};
    height: 40px;
    padding: 9px 16px;
  }

  textarea {
    border-radius: 8px;
    border: 1px solid ${props => props.theme.colors.clearGray};
    background: ${props => props.theme.colors.primaryWhite};
    padding: 9px 16px;
  }
`;

export const GeneralActions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;
